module.exports = __webpack_public_path__ + "static/media/Centro-de-Salud-ya-no-monitorea-el-aire.a15c8b67.jpg";